import { Link } from 'react-router-dom';

const footerLinks = {
  product: {
    title: '产品',
    links: [
      { label: '功能介绍', path: '/#features' },
      { label: '下载安装', path: '/#download' },
      { label: '分类浏览', path: '/category' },
      { label: '文章资讯', path: '/articles' },
    ],
  },
  support: {
    title: '支持',
    links: [
      { label: '常见问题', path: '/#faq' },
      { label: '使用指南', path: '/articles' },
      { label: '联系我们', path: '/about#contact' },
      { label: '用户反馈', path: '/about#contact' },
    ],
  },
  about: {
    title: '关于',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '用户口碑', path: '/about#testimonials' },
      { label: '隐私政策', path: '/about' },
      { label: '服务条款', path: '/about' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
                <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-play-fill text-background-50 text-lg"></i>
                </div>
                <span className="text-xl font-heading font-bold text-background-50">
                  抖阴pro
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                抖阴pro是备受用户喜爱的短视频内容平台，致力于为全球用户提供丰富、优质、有趣的短视频内容体验。
              </p>
            </div>

            {Object.values(footerLinks).map((section) => (
              <div key={section.title}>
                <h4 className="text-sm font-semibold text-background-50 mb-4">
                  {section.title}
                </h4>
                <ul className="flex flex-col gap-3">
                  {section.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; 2026 抖阴pro. 保留所有权利.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-background-500 hover:text-background-200 transition-colors duration-200 text-sm whitespace-nowrap" rel="nofollow">隐私政策</a>
              <a href="#" className="text-background-500 hover:text-background-200 transition-colors duration-200 text-sm whitespace-nowrap" rel="nofollow">服务条款</a>
              <a href="#" className="text-background-500 hover:text-background-200 transition-colors duration-200 text-sm whitespace-nowrap" rel="nofollow">Cookie政策</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}